import React from "react";
import { ColumnValueRendererProps } from "../table.data.interface";
import { Tooltip } from "@vibe/core";

const HourColumn = ({ columnData, isPreview }: ColumnValueRendererProps) => {
  if (columnData.value === "Empty Column") {
    return null;
  }

  let displayText = columnData.text;

  if (!displayText && columnData.value) {
    try {
      const parsed =
        typeof columnData.value === "string"
          ? JSON.parse(columnData.value)
          : columnData.value;
      const hour = parsed?.hour ?? 0;
      const minute = parsed?.minute ?? 0;
      const date = new Date(2000, 0, 1, hour, minute);
      displayText = date.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch {
      displayText = String(columnData.value);
    }
  }

  if (!displayText) {
    return null;
  }

  if (isPreview) {
    return (
      <div className="flex overflow-hidden">
        <Tooltip content={displayText}>
          <p className="text-sm font-medium truncate whitespace-nowrap">{displayText}</p>
        </Tooltip>
      </div>
    );
  }

  return (
    <Tooltip content={displayText}>
      <div className="font-semibold">{displayText}</div>
    </Tooltip>
  );
};

export default HourColumn;
